export enum POOL_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING_OFFER = 'pendingOffer',
  WORKER_UNDER_REVIW = 'underReview',
  NEW_APPLICATION = 'newApplication',
}
